import React from 'react'
import { useLanguage } from '../../context/LanguageContext';

const AboutBox = () => {

    const { translations } = useLanguage();
    
  return (
    <div className="about__boxes grid">
        <div className="about__box">
            <i className="about__icon icon-fire"></i>

            <div>
                <h3 className="about__title">23</h3>
                <span className="about__subtitle">{translations.projects}</span>
            </div>
        </div>

        <div className="about__box">
            <i className="about__icon icon-cup"></i>

            <div>
                <h3 className="about__title">20000</h3>
                <span className="about__subtitle">{translations.cups}</span>
            </div>
        </div>

        <div className="about__box">
            <i className="about__icon icon-people"></i>

            <div>
                <h3 className="about__title">2ª</h3>
                <span className="about__subtitle">{translations.experiences}</span>
            </div>
        </div>

        <div className="about__box">
            <i className="about__icon icon-badge"></i>

            <div>
                <h3 className="about__title">6</h3>
                <span className="about__subtitle">{translations.certificates}</span>
            </div>
        </div>
    </div>
  )
}

export default AboutBox